
export default function AddButton() {
    return (
        <i className="pi pi-plus-circle text-[#344054]" /> 
    )
}